import { addAuthInterceptors } from '@dentalux/security';
import axios from 'axios';
import format from 'date-fns-tz/format';
import addWeeks from 'date-fns/addWeeks';
import { formatIsoInTimeZone } from 'src/helpers/date';
const http = axios.create({
  baseURL: process.env.NEXT_PUBLIC_ECHO_CORE_RECORD_URL
});
addAuthInterceptors(http);
const formatToTimezone = ({
  date,
  timeZone
}) => format(new Date(date), "yyyy-MM-dd'T'HH:mm:ss.SSSXXX", {
  timeZone
});
export const getCategorisedBookableTreatmentBundles = async ({
  personReferenceId,
  clinicReferenceId,
  ...params
}) => {
  const {
    data
  } = await http.get(`/v1/external/persons/${personReferenceId}/clinics/${clinicReferenceId}/bookable-treatment-bundles/categorised`, {
    params
  });
  return data;
};
export const getBookableTreatmentBundles = async ({
  personReferenceId,
  clinicReferenceId,
  ...params
}) => {
  const {
    data
  } = await http.get(`/v1/external/persons/${personReferenceId}/clinics/${clinicReferenceId}/bookable-treatment-bundles`, {
    params
  });
  return data;
};
export const getTreatmentBundle = async ({
  treatmentBundleReferenceId,
  clinicReferenceId
}) => {
  const {
    data
  } = await http.get(`/v1/public/bookable-treatment-bundles/${treatmentBundleReferenceId}`, {
    params: {
      clinicReferenceId
    }
  });
  return data;
};
export const getUpsellsForBookableTreatmentBundle = async ({
  treatmentBundleReferenceId,
  clinicReferenceId,
  personReferenceId,
  timeZone = 'Europe/Berlin'
}) => {
  const {
    data
  } = await http.get(`/v2/public/bookable-treatment-bundles/${treatmentBundleReferenceId}/upsells`, {
    params: {
      clinicReferenceId,
      personReferenceId,
      end: formatToTimezone({
        timeZone,
        date: addWeeks(new Date(), 6)
      })
    }
  });
  return data;
};
export const getRescheduleAvailabilities = async ({
  timeSlot,
  personReferenceId,
  timeZone = 'Europe/Berlin'
}) => {
  const {
    appointmentBundleReferenceId,
    startDateTime,
    endDateTime
  } = timeSlot;
  const {
    data
  } = await http.get(`/v1/external/persons/${personReferenceId}/time-slots`, {
    params: {
      appointmentBundleReferenceId,
      start: formatToTimezone({
        timeZone,
        date: startDateTime
      }),
      end: formatToTimezone({
        timeZone,
        date: endDateTime
      })
    }
  });
  return data;
};
export const getAvailabilities = async ({
  timeSlot,
  personReferenceId,
  timeZone = 'Europe/Berlin'
}) => {
  const {
    clinicReferenceId,
    treatmentBundleReferenceId,
    practitionerReferenceIds,
    startDateTime,
    endDateTime
  } = timeSlot;
  const {
    data
  } = await http.get(`/v1/external/persons/${personReferenceId}/time-slots`, {
    params: {
      treatmentBundleReferenceId,
      clinicReferenceId,
      start: formatToTimezone({
        timeZone,
        date: startDateTime
      }),
      end: formatToTimezone({
        timeZone,
        date: endDateTime
      }),
      employeeReferenceIds: practitionerReferenceIds.join(',')
    }
  });
  return data;
};
export const createBooking = async ({
  personReferenceId,
  practitionerReferenceId,
  start,
  params,
  timeZone = 'Europe/Berlin',
  ...body
}) => {
  const {
    data
  } = await http.post(`/v1/external/persons/${personReferenceId}/appointment-bundles`, {
    ...body,
    employeeReferenceId: practitionerReferenceId,
    start: formatIsoInTimeZone(start, timeZone)
  }, {
    params
  });
  return data;
};
export const rescheduleBooking = async ({
  personReferenceId,
  appointmentBundleReferenceId,
  start,
  params,
  timeZone = 'Europe/Berlin'
}) => {
  const {
    data
  } = await http.post(`/v1/external/persons/${personReferenceId}/appointment-bundles/${appointmentBundleReferenceId}/reschedule`, {
    start: formatIsoInTimeZone(start, timeZone)
  }, {
    params
  });
  return data;
};
export const cancelBooking = async ({
  personReferenceId,
  appointmentBundleReferenceId,
  params,
  ...body
}) => {
  const {
    data
  } = await http.post(`/v1/external/persons/${personReferenceId}/appointment-bundles/${appointmentBundleReferenceId}/cancellations`, body, {
    params: {
      cancellationSource: 'HEALTH_ASSISTANT',
      ...params
    }
  });
  return data;
};